import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { IconProp } from '@fortawesome/fontawesome-svg-core';
import type { SingleValueProps } from 'react-select';
import type { CSSProperties } from 'react';

type SingleValueFlagOption = {
  label: string;
  value?: string;
  icon?: IconProp;
  flag?: string;
};

type SingleValueFlagProps = SingleValueProps<SingleValueFlagOption, false>;

const SingleValueFlag = (props: SingleValueFlagProps) => {
  const { innerProps, getStyles, ...rest } = props;
  return (
    <>
      <div
        {...innerProps}
        style={{
          ...(getStyles('singleValue', rest as never) as CSSProperties),
          color: 'var(--falcon-body-color)'
        }}
        className="d-flex align-items-center gap-1"
      >
        {props.data?.icon ? (
          <FontAwesomeIcon icon={props.data.icon} title={props.data.label} />
        ) : (
          props.data?.flag && (
            <img
              src={props.data.flag}
              alt="country icon"
              width="20px"
              loading="lazy"
              height="11px"
            />
          )
        )}
        {props.data.label}
      </div>
    </>
  );
};

export default SingleValueFlag;
